import React from "react";

/*
    Account Icon
    props:
        - title: string, override the default title 'Account'
        - color: string, override the default color '#00549A' (bell blue)
*/

const DownloadIcon = (props) => (
    <svg className={props.className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Download"}</title>
        <path
            d="M2.5 9.5V13.5H8H13.5V9.5M8 2.5V10.5M8 10.5L11.3333 7.16667M8 10.5L4.66667 7.16667"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default DownloadIcon;
